import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Facsimile } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { initialValuesFacsimile, validationSchemaFacsimile } from "./FacsimileCommon"
import FacsimileForm from "./FacsimileForm"
import { useMemo } from "react"
import { useFacsimileCreate } from "../../hooks/facsimili"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function FacsimileCreate() {
  const createFacsimile = useFacsimileCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Facsimili", href: "/edizioni/facsimili" }, { label: "Creazione Facsimile" }])

  const initialValues = useMemo(() => initialValuesFacsimile(), [])
  const validationSchema = useMemo(() => validationSchemaFacsimile(true), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo facsimile</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createFacsimile.mutateAsync(values as Facsimile).then((facsimile) => {
                navigate(`/edizioni/facsimili`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <FacsimileForm showEdizione col={8} />
                </Container>
                <BottomFormFixed url="/edizioni/facsimili" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
